import { createContext } from 'react'

/**
 * Store path prefix the editable fields of the enclosing unit live under
 * (`BuilderUnit`'s `dataBaseLocation`). Row-level primitives (`BuilderRowField`,
 * `BuilderRowToolbar`…) need it to express a cell's absolute store path as a
 * path RELATIVE to its top-level field (`0.destinations.2.city`), which is what
 * the edit runtime commits through `setFieldValue(field, wholeArray)`.
 *
 * Default `~~` = legacy blocks whose data sits at the store root (`~~.items`).
 */
export const UnitDataBaseContext = createContext('~~')
